var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"breadcrumb-item",attrs:{"to":_vm.info.to}},[_vm._v(" "+_vm._s(_vm.info.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }